"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Empty = void 0;
var Empty_1 = require("./Empty");
Object.defineProperty(exports, "Empty", { enumerable: true, get: function () { return Empty_1.Empty; } });
